/* Stienhardt - brand craftsmanship video banner (2026-06-27 v4):
   autoplay + muted + LOOP forever, 1080p, text overlay ("Every ring tells a
   story"), unmute button. Lazy: only starts when scrolled near viewport.
   Revert = remove file + <script> + CSS. */
(function () {
  'use strict';
  var POSTER='https://cdn.shopify.com/s/files/1/0708/5876/8690/files/preview_images/380bb86df0fe4dadb5a4c2fba081db94.thumbnail.0000000000.jpg?v=1782602282', SRC1080='https://cdn.shopify.com/videos/c/vp/380bb86df0fe4dadb5a4c2fba081db94/380bb86df0fe4dadb5a4c2fba081db94.HD-1080p-7.2Mbps-87579797.mp4', SRC720='https://cdn.shopify.com/videos/c/vp/380bb86df0fe4dadb5a4c2fba081db94/380bb86df0fe4dadb5a4c2fba081db94.HD-720p-4.5Mbps-87579797.mp4';
  function html(){
    return '<div class="sp-dvid__frame">'
      +'<video class="sp-dvid__v" muted loop playsinline preload="none" poster="'+POSTER+'" aria-label="Stienhardt ring setting craftsmanship"></video>'
      +'<div class="sp-dvid__scrim"></div>'
      +'<div class="sp-dvid__overlay">'
        +'<h2 class="sp-dvid__h">Set and Finished in New York City</h2>'
        +'<p class="sp-dvid__p">Pair this diamond with a Stienhardt setting and our jewelers will set and finish the completed ring in New York City.</p>'
      +'</div>'
    +'</div>';
  }
  function setup(sec){
    var v=sec.querySelector('.sp-dvid__v'); if(!v) return;
    var loaded=false;
    function load(){ if(loaded)return; loaded=true;
      v.innerHTML='<source src="'+SRC1080+'" type="video/mp4"><source src="'+SRC720+'" type="video/mp4">';
      v.load(); var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){});
    }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ load(); io.disconnect(); } });},{rootMargin:'250px'});
      io.observe(v);
    } else { load(); }
  }
  function placeReviews(sec){
    var rev=document.querySelector('.sp-rev');
    if(rev && sec && rev!==sec.nextElementSibling){ sec.after(rev); }
  }
  function run(){
    var anchor=document.querySelector('.sp-cc'); if(!anchor) return false;
    var sec=document.querySelector('.sp-dvid');
    if(!sec){
      sec=document.createElement('section'); sec.className='sp-dvid'; sec.innerHTML=html();
      anchor.parentNode.insertBefore(sec, anchor);
      setup(sec);
    }
    placeReviews(sec);
    return true;
  }
  var n=0,iv=setInterval(function(){n++;run();if(n>60)clearInterval(iv);},250);
  var mp=document.getElementById('mainproduct'); if(mp) new MutationObserver(run).observe(mp,{childList:true,subtree:true});
})();
